import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ProgressBar } from 'react-bootstrap';
import QuestionsContainer from '../common/QuestionsContainer';
import { postRequest } from '../../requestUtils';
import logoImg from '../../../assets/images/Logo_Gray.svg';
import './ProjectLead.scss';

class ProjectLead extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
    };
    this.renderQuestion = this.renderQuestion.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.previousPage = this.previousPage.bind(this);
    this.nextPage = this.nextPage.bind(this);
    this.sendAnswers = this.sendAnswers.bind(this);
  }

  sendAnswers() {
    const {
      projectLeadUrl, csrfToken, questionableId, afterSubmit,
    } = this.props;
    this.nextPage();
    postRequest(
      projectLeadUrl,
      { survey_id: questionableId },
      csrfToken,
    ).then(() => afterSubmit());
  }

  previousPage() {
    const { currentPage } = this.state;
    this.setState({ currentPage: currentPage - 1 });
  }

  nextPage() {
    const { currentPage } = this.state;
    this.setState({ currentPage: currentPage + 1 });
  }

  renderProgressBar() {
    const { questionnaireQuestions } = this.props;
    const { currentPage } = this.state;
    const max = Object.keys(questionnaireQuestions).length;
    return (
      <div className="progress-bar-container">
        <ProgressBar now={currentPage} max={max} />
        <span className="progress-text body-text-3">
          {currentPage}
          /
          {max}
        </span>
      </div>
    );
  }

  renderQuestion() {
    const { currentPage } = this.state;
    const {
      questionnaireQuestions,
      questionableId,
      questionableType,
      csrfToken,
    } = this.props;

    const questionnaireQuestionIds = questionnaireQuestions[currentPage].map((x) => x.id);
    return (
      <div key={currentPage}>
        <QuestionsContainer
          questionIds={questionnaireQuestionIds}
          questionableId={questionableId}
          questionableType={questionableType}
          csrfToken={csrfToken}
          forceSmallQuestionTitle
          owner
        />
      </div>
    );
  }

  renderFooter() {
    const { questionnaireQuestions } = this.props;
    const { currentPage } = this.state;
    if (currentPage <= 1) {
      return (
        <button className="btn btn-primary next-btn" onClick={() => this.nextPage()}>
          Next
          <i className="ms-2 fa fa-chevron-right" />
        </button>
      );
    } if (currentPage > 1 && currentPage < Object.keys(questionnaireQuestions).length) {
      return (
        <div>
          <button className="btn btn-primary-mute back-btn" onClick={() => this.previousPage()}>
            <i className="fa fa-chevron-left" />
          </button>
          <button className="btn btn-primary next-btn" onClick={() => this.nextPage()}>
            <i className="fa fa-chevron-right" />
          </button>
        </div>
      );
    }
    return (
      <div>
        <button className="btn btn-primary-mute back-btn" onClick={() => this.previousPage()}>
          <i className="fa fa-chevron-left" />
        </button>
        <button
          className="btn btn-primary project-lead-send-answers"
          onClick={() => this.sendAnswers()}
        >
          Send answers
        </button>
      </div>
    );
  }

  render() {
    const { questionnaireQuestions } = this.props;
    const { currentPage } = this.state;
    if (currentPage <= Object.keys(questionnaireQuestions).length) {
      return (
        <div>
          <div className="logo"><img src={logoImg} alt="Clora" /></div>
          {currentPage === 1 && (
          <div className="body-text-2 mt-4">
            These answers will allow Clora to tailor the right demo for your organization:
          </div>
          )}
          {this.renderProgressBar()}
          {this.renderQuestion()}
          <div className="navigation">{this.renderFooter()}</div>
        </div>
      );
    }
    return (
      <div className="info-sent">
        <div className="logo"><img src={logoImg} alt="Clora" /></div>
        <h2>Your information has been sent!</h2>
        <div className="body-text-2">
          A copy of your answers was sent to your inbox. Clora will contact
          you shortly to let you know more about our services!
        </div>
      </div>
    );
  }
}

ProjectLead.propTypes = {
  questionnaireQuestions: PropTypes.shape({}).isRequired,
  questionableId: PropTypes.number.isRequired,
  questionableType: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  projectLeadUrl: PropTypes.string.isRequired,
  afterSubmit: PropTypes.func,
};

ProjectLead.defaultProps = {
  afterSubmit: () => {},
};

export default ProjectLead;
